/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Presets_None_TitleInputs */

const en_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Presets Found`)
};

const fr_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun préréglage trouvé`)
};

const de_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellungen gefunden`)
};

const it_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset trovato`)
};

const ru_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предустановки не найдены`)
};

const es_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron ajustes preestablecidos`)
};

const zh_cn2_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到预设`)
};

const ja_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが見つかりません`)
};

const hi_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई प्रीसेट नहीं मिला`)
};

const pt_pt2_subtitle_export_presets_none_title = /** @type {(inputs: Subtitle_Export_Presets_None_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição encontrada`)
};

/**
* | output |
* | --- |
* | "No Presets Found" |
*
* @param {Subtitle_Export_Presets_None_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_presets_none_title = /** @type {((inputs?: Subtitle_Export_Presets_None_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Presets_None_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_presets_none_title(inputs)
	if (locale === "de") return de_subtitle_export_presets_none_title(inputs)
	if (locale === "it") return it_subtitle_export_presets_none_title(inputs)
	if (locale === "ru") return ru_subtitle_export_presets_none_title(inputs)
	if (locale === "es") return es_subtitle_export_presets_none_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_presets_none_title(inputs)
	if (locale === "ja") return ja_subtitle_export_presets_none_title(inputs)
	if (locale === "hi") return hi_subtitle_export_presets_none_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_presets_none_title(inputs)
	return en_subtitle_export_presets_none_title(inputs)
});